import { render, staticRenderFns } from "./Swiper.vue?vue&type=template&id=f08fe776&scoped=true"
import script from "./Swiper.vue?vue&type=script&lang=js"
export * from "./Swiper.vue?vue&type=script&lang=js"
import style0 from "./Swiper.vue?vue&type=style&index=0&id=f08fe776&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08fe776",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f08fe776')) {
      api.createRecord('f08fe776', component.options)
    } else {
      api.reload('f08fe776', component.options)
    }
    module.hot.accept("./Swiper.vue?vue&type=template&id=f08fe776&scoped=true", function () {
      api.rerender('f08fe776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/Swiper.vue"
export default component.exports